
export const user = {
    namespaced: true,
    state: () => ({
        me: null,
        activeUser: null
    }),
    getters:{
        me: (state) => state.me,
        activeUser: (state) => state.activeUser,
        isRole: (state) => state.me?.role,
    },
    mutations: {
        SET_ACTIVE_USER: (state, payload) => {
            state.activeUser = payload
        },
        SET_BLOCKED_USER: (state, payload) => {
            let { user } = state.activeUser;
            state.activeUser = {...state.activeUser, user: {...user, blockedAt: payload}}
        },
        SET_USER: (state, payload) => {
            state.me = payload
        },
        SET_LOGOUT: (state, payload) => {
            state.me = null
        },
        SET_ROLE: (state, payload) => {
            state.me.role = payload
        },
    },
    actions: {
        USER_ROLE: (context, payload) => {
            context.commit('SET_ROLE', payload)
        },
        USER: (context, payload) => {
            context.commit('SET_USER', payload)
        },
        LOGOUT: (context, payload) => {
            context.commit('SET_LOGOUT', payload)
        },

    }
}